import { const_var, params } from "../../redux/reducers/reducer";
import { makeComponentArrayForOtherBuilding } from "../building_component/doorWindows.helper";

export const setBuildingComparisonData = (state, action, cuBuilding) => {
	const [compareManufacturer, compareId] = action.iiD.split("_");
	const_var.checkPickThisBuilding = true;
	const_var[`${"NoCompareData"}${compareId}`] = false;
	makeComponentArrayForOtherBuilding(state, action.iiD);
	const_var.engineer_drawings_price_changed = true;
	state.const_var.showComparePrices = true;
	cuBuilding.setComparePricingData(action.iiD);
	if (params.add_right_lean != true && params.add_left_lean != true && params.add_front_lean != true && params.add_back_lean != true) {
		state.const_var.comparisionLoadermfg1 = false;
		state.const_var.comparisionLoadermfg2 = false;
	}

	return {
		...state,
		newColor: action + const_var.i_g_A_y.length + const_var.NoCompareData1 + const_var.NoCompareData2 + const_var.comparisionLoadermfg1 + const_var.comparisionLoadermfg2 + params.m_s_n_1 + params.m_s_n_2
	};
};
export const handleCompareSummaryModal = (state, action) => {
	state.const_var.isForStandardBuilding = false;
	state.const_var.showComparePrices = false;
	state.params.m_s_n_1 = "";
	state.params.m_s_n_2 = "";
	state.params.m_n_f_1 = "";
	state.params.m_n_f_2 = "";
	state.selectedManufacturer = 0;
	state.isShowSummaryModal = false;
	state.isShowComparePriceModal = false;
	return {
		...state,
		action
	};
};
export const handleShowCompareModal = (state, action) => {
	state.const_var.isForStandardBuilding = false;
	state.const_var.showComparePrices = false;
	state.params.m_s_n_1 = "";
	state.params.m_s_n_2 = "";
	state.params.m_n_f_1 = "";
	state.params.m_n_f_2 = "";
	state.selectedManufacturer = 0;
	state.isShowComparePriceModal = !state.isShowComparePriceModal;

	state.const_var.comparisionLoadermfg1 = false;
	state.const_var.comparisionLoadermfg2 = false;
	state.const_var.NoCompareData1 = false;
	state.const_var.NoCompareData2 = false;

	return {
		...state,
		action
	};
};
